const ListItem = ({ className, children, text,  }) =>{
    return(
        <li className={className}>{children ? children : text}</li>
    )
}
export default ListItem